/*
 * Client-side timing beacon.
 *
 * The server-side TIMING line stops at the moment Tomcat hands the response to
 * nginx. Everything after that - transfer to the phone, HTML parse, and the
 * document-ready JavaScript - is invisible from the server, and on mobile that
 * is where the remaining time goes. This reports those phases so they land in
 * Graylog next to the server line for the same page.
 *
 * Fire-and-forget: sendBeacon, wrapped in try/catch, never blocks the page.
 */
(function () {

    if (!window.performance || !window.performance.getEntriesByType) {
        return;
    }

    function send() {
        try {
            var nav = performance.getEntriesByType('navigation')[0];
            if (!nav) {
                return;
            }

            var data = {
                url: location.pathname,
                // Server work plus network latency, up to the first byte.
                ttfb: Math.round(nav.responseStart),
                // Time spent receiving the HTML body.
                download: Math.round(nav.responseEnd - nav.responseStart),
                // Browser parsing the HTML into a DOM.
                parse: Math.round(nav.domInteractive - nav.responseEnd),
                // document-ready handlers: our own JavaScript.
                ready: Math.round(nav.domContentLoadedEventEnd - nav.domInteractive),
                // Images, fonts, deferred scripts.
                load: Math.round(nav.loadEventEnd - nav.domContentLoadedEventEnd),
                total: Math.round(nav.loadEventEnd),
                // Bytes actually over the wire vs. after gunzip.
                wire: nav.transferSize || 0,
                html: nav.decodedBodySize || 0,
                // How much DOM the phone had to build.
                nodes: document.getElementsByTagName('*').length
            };

            try {
                data.rows = document.querySelectorAll('#link-table tr[gr=a]').length;
            } catch (ignored) {
                data.rows = -1;
            }

            // Set by the instrumented sort in searchSorting.js, when it ran.
            if (typeof window.IATI_SORT_MS === 'number') {
                data.sort = Math.round(window.IATI_SORT_MS);
                data.sortRows = window.IATI_SORT_ROWS || 0;
            }

            // Device class - a 3s ready on a fast phone and on a slow one are
            // different problems.
            if (navigator.deviceMemory) { data.mem = navigator.deviceMemory; }
            if (navigator.hardwareConcurrency) { data.cpu = navigator.hardwareConcurrency; }
            if (navigator.connection && navigator.connection.effectiveType) {
                data.net = navigator.connection.effectiveType;
            }
            data.vw = window.innerWidth;

            var body = new URLSearchParams();
            for (var key in data) {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    body.append(key, data[key]);
                }
            }

            if (navigator.sendBeacon) {
                navigator.sendBeacon('/clientTiming', body);
            }
        } catch (ignored) {
            // Measurement must never break the page.
        }
    }

    // loadEventEnd is only final once load has finished, hence the deferral.
    if (document.readyState === 'complete') {
        setTimeout(send, 0);
    } else {
        window.addEventListener('load', function () { setTimeout(send, 0); });
    }
})();
